
import { useState, useEffect } from 'react';
import { Card, CardBody, CardTitle, Collapse } from 'reactstrap';
import { useTranslation } from 'react-i18next';

import '../styles/CertificateCard.css';
import '../styles/FadeInAnimation.css';

import Aos from 'aos';
import 'aos/dist/aos.css';

const CertificateCard = ({ image, title, numberOfCertificates }) => {

    const [collapse, setCollapse] = useState(false);
    const toggle = () => setCollapse(!collapse);

    const { t } = useTranslation();

    // Initialize AOS for animations
    useEffect(() => {
        Aos.init({ duration: 1000, once: true });
    }, []); 

    return (
        <Card className='certificate-card' data-aos="fade-in">
            <CardBody className='certificate-card-body'>
                <div className='certificate-image-container'>
                    <img
                        className='certificate-image fadeIn-animation'
                        alt="Certificate"
                        src={image}
                    />
                </div>
                <div className='certificate-card-body-content'>
                    <CardTitle className='certificate-card-title' tag="h5">
                        {title}
                    </CardTitle>
                    <div>
                        <div className="certificate-card-footer" onClick={toggle}>
                            <span className="certificate-card-link">{t('number_of_certifications_title')}</span>
                            <i className={`bi bi-${collapse ? "dash" : "plus"}-circle-fill certificate-card-icon`} aria-hidden="true"></i>
                        </div>

                        <Collapse
                            isOpen={collapse}
                        >
                            <Card className='certificate-card-content'>
                                <CardBody className='certificate-card-content-body'>
                                    <p>{t('number_of_certifications')} {numberOfCertificates}</p>
                                </CardBody>
                            </Card>
                        </Collapse>
                    </div>
                </div>
            </CardBody>
        </Card>
    );
}
export default CertificateCard;
